import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCookiePage } from '../../../modules/content/selectors';
import contentBackup from '../../../../resources/cookieBackup.json';

export const PrivacyPolicy = ({ contentStackContent }) => {
  let content;
  if (contentStackContent) {
    content = contentStackContent;
  } else {
    content = contentBackup;
  }
  return (
    <div className="privacy">
      <div className="container--fixed">
        <h1 className="privacy__header" dangerouslySetInnerHTML={{ __html: content.title }}  />
        <div className="cms-content" dangerouslySetInnerHTML={{ __html: content.text }}  />
      </div>
    </div>
  );
};

PrivacyPolicy.propTypes = {
  contentStackContent: PropTypes.object
};

const mapStateToProps = (state) => ({
  contentStackContent: getCookiePage(state)
});

export default connect(mapStateToProps)(PrivacyPolicy);
